import React from "react";
import PropTypes from "prop-types";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import Login from "./Login";
import Logout from "./Logout";
import Registration from "./Registration";
import ForgetPassword from "./ForgetPassword";
import ConfirmMail from "./ConfirmMail";
import LockScreen from "./LockScreen";
import PMSesLogin from "./PMSesLogin";
import TwoFactorAuthentication from "./TwoFactorAuth/TwoFactorAuthentication";
import ApiplusPayment from "./payment/ApiplusPayment";
import SaiRegistration from "./SaiAuth/SaiRegistration";
import SaiRegistrationDownload from "./SaiAuth/SaiRegistrationDownload";
import { GetParamterFromLink } from "../../helpers/utils";
const AuthBasicRoutes = ({ match: { url } }) => {
  
  return <>
      <Switch>
        <Route path={`${process.env.PUBLIC_URL}/authentication/login`} exact component={Login} />
        <Route path={`${process.env.PUBLIC_URL}/authentication/pmses-login`} exact component={PMSesLogin} />
        <Route path={`${process.env.PUBLIC_URL}/authentication/logout`} exact component={Logout} />
        <Route path={`${process.env.PUBLIC_URL}/authentication/register`} exact component={Registration} />
        <Route path={`${process.env.PUBLIC_URL}/authentication/sai-register`} exact render={(props) => 
        {const isDownload = String(GetParamterFromLink("isdownload") || "").toLowerCase() === "true";
          return isDownload ? (<SaiRegistrationDownload {...props} />) : (<SaiRegistration {...props} />);
        }}/>
        <Route path={`${process.env.PUBLIC_URL}/authentication/forget-password`} exact component={ForgetPassword} />
        <Route path={`${process.env.PUBLIC_URL}/authentication/confirm-mail`} exact component={ConfirmMail} />
        <Route path={`${process.env.PUBLIC_URL}/authentication/lock-screen`} exact component={LockScreen} />
        <Route path={`${process.env.PUBLIC_URL}/authentication/two-factor-authentication`} exact component={TwoFactorAuthentication} />
        <Route path={`${process.env.PUBLIC_URL}/authentication/api-plus-payment`} exact component={ApiplusPayment} />
        
      </Switch>
  </>
};

AuthBasicRoutes.propTypes = { match: PropTypes.object.isRequired };

export default withRouter(AuthBasicRoutes);
